module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent",
    attrs: {
      "align": "center"
    }
  }, [_c('mu-appbar', {
    staticStyle: {
      "height": "0.8rem",
      "color": "black",
      "background-color": "#FFFFFF",
      "box-shadow": "1px 4px 90' 20%",
      "position": "fixed",
      "top": "0%"
    }
  }, [_c('mu-icon', {
    staticStyle: {
      "margin-top": "0.05rem"
    },
    attrs: {
      "slot": "left",
      "value": "keyboard_arrow_left",
      "color": "#363636"
    },
    on: {
      "click": function($event) {
        return _vm.goback()
      }
    },
    slot: "left"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "font-size": "0.3rem",
      "margin-top": "0.15rem",
      "font-family": "Microsoft YaHei",
      "height": "0.8rem"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "90%",
      "margin-top": "0.04rem"
    },
    attrs: {
      "src": require("../../../static/Brand/GreenTreeDetail/logo.png")
    }
  })]), _vm._v(" "), _c('mu-icon', {
    staticStyle: {
      "margin-top": "0.05rem"
    },
    attrs: {
      "slot": "right",
      "value": "keyboard_arrow_left",
      "color": "#FFFFFF"
    },
    slot: "right"
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "none",
      "border-top": "1px solid #F1F1F1"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "none",
      "border-top": "1px solid #F1F1F1"
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "none",
      "border-top": "1px solid #F1F1F1"
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border": "none",
      "border-top": "1px solid #F1F1F1"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "color": "#FFFFFF",
      "margin-bottom": "1.5rem"
    },
    attrs: {
      "id": "bottomMessage"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("立即留言")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "0.2rem"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "0.75rem",
      "border-radius": "0.06rem",
      "border": "1px solid #e2e2e2",
      "text-align": "left",
      "width": "90%",
      "margin-top": "0.13rem"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Name),
      expression: "Name"
    }],
    staticStyle: {
      "margin-top": "0.13rem",
      "border": "0",
      "outline": "0",
      "color": "#A6A4A4",
      "width": "90%",
      "margin-left": "0.2rem"
    },
    attrs: {
      "placeholder": "姓名*"
    },
    domProps: {
      "value": (_vm.Name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.75rem",
      "border-radius": "0.06rem",
      "border": "1px solid #e2e2e2",
      "text-align": "left",
      "width": "90%",
      "margin-top": "0.13rem"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.UserPhone),
      expression: "UserPhone"
    }],
    staticStyle: {
      "margin-top": "0.13rem",
      "border": "0",
      "outline": "0",
      "color": "#A6A4A4",
      "width": "90%",
      "margin-left": "0.2rem"
    },
    attrs: {
      "placeholder": "电话*"
    },
    domProps: {
      "value": (_vm.UserPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.UserPhone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.75rem",
      "border-radius": "0.06rem",
      "border": "1px solid #e2e2e2",
      "text-align": "left",
      "width": "90%",
      "margin-top": "0.13rem"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.City),
      expression: "City"
    }],
    staticStyle: {
      "margin-top": "0.13rem",
      "border": "0",
      "outline": "0",
      "color": "#A6A4A4",
      "width": "90%",
      "margin-left": "0.2rem"
    },
    attrs: {
      "placeholder": "城市"
    },
    domProps: {
      "value": (_vm.City)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.City = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.75rem",
      "border-radius": "0.06rem",
      "border": "1px solid #e2e2e2",
      "text-align": "left",
      "width": "90%",
      "margin-top": "0.13rem"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticStyle: {
      "margin-top": "0.13rem",
      "border": "0",
      "outline": "0",
      "color": "#A6A4A4",
      "width": "90%",
      "margin-left": "0.2rem"
    },
    attrs: {
      "placeholder": "留言"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('input', {
    staticStyle: {
      "letter-spacing": "0.1rem",
      "width": "90%",
      "height": "0.8rem",
      "background-color": "#73B43C",
      "border-radius": "4px",
      "border-width": "0",
      "font-size": "18px",
      "color": "#f5f5f5",
      "margin-top": "0.13rem"
    },
    attrs: {
      "type": "button",
      "value": "提交留言"
    },
    on: {
      "click": _vm.messagebtn
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "buttonText",
    staticStyle: {
      "font-size": "0.28rem",
      "color": "#999999"
    }
  }, [_vm._v("格林豪泰酒店（中国）有限公司版权所有")]), _vm._v(" "), _c('div', {
    staticClass: "buttonText",
    staticStyle: {
      "font-size": "0.1rem",
      "color": "#999999"
    }
  }, [_vm._v("投资有风险，选择需谨慎")])]), _vm._v(" "), _vm._m(4), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "id": "alertline",
      "message": _vm.hintMsg
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "position": "relative",
      "margin-top": "1rem"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../../../static/Brand/GreenTreeDetail/hotelface.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "title"
  }, [_vm._v("品牌简介")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.29rem",
      "margin-left": "0.2rem",
      "margin-right": "0.2rem",
      "text-align": "justify",
      "text-justify": "inter-ideograph"
    }
  }, [_vm._v("青皮树酒店成立于2013年，绿色天然的环保设计元素，让年轻白领身处都市之中，也能感受自然清新的入住体验。酒店大多数房间价格在150-300元，倡导舒适、绿色、环保、低碳的生活方式，提供24小时免费光纤上网等配套设施。")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "90%",
      "margin": "auto"
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("加盟条件")]), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../../../static/Brand/GreenTreeDetail/joinCondition.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "90%",
      "margin": "auto"
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#363636",
      "font-size": "0.4rem",
      "margin-top": "0.5rem",
      "font-weight": "bold",
      "margin-bottom": "0.5rem",
      "border-bottom": "2px solid #73B43C",
      "width": "2.4rem"
    }
  }, [_vm._v("加盟收费标准")]), _vm._v(" "), _c('div', [_c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": require("../../../static/Brand/GreenTreeDetail/join.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "0.2rem",
      "text-align": "left"
    }
  }, [_vm._v("*达到公司奖励政策标准,可根据政策享受优惠 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mu-bottom-nav mu-bottom-nav-shift",
    staticStyle: {
      "position": "fixed",
      "bottom": "0%",
      "user-select": "none",
      "cursor": "pointer",
      "-webkit-appearance": "none",
      "-webkit-box-shadow": "#000000 1px 4px 6px",
      "-moz-box-shadow": "#000000 1px 4px 6px",
      "box-shadow": "#000000 1px 4px 6px",
      "background": "#FFFFFF",
      "z-index": "9999"
    },
    attrs: {
      "tabindex": "0"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "font-size": "0.3rem",
      "color": "#4B4B4B",
      "margin-right": "1rem"
    }
  }, [_c('a', {
    attrs: {
      "href": "tel:4006-998-998"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "src": require("../../../static/Brand/GreenTreeDetail/tel.png")
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "80%",
      "float": "right",
      "color": "#363636"
    }
  }, [_vm._v(" 电话咨询  ")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "font-size": "0.3rem",
      "color": "#4B4B4B"
    }
  }, [_c('a', {
    attrs: {
      "href": "#bottomMessage"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "20%"
    },
    attrs: {
      "src": require("../../../static/Brand/GreenTreeDetail/message.png")
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "80%",
      "float": "right",
      "color": "#363636"
    }
  }, [_vm._v("  在线留言   ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9da4b1fe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/BrandDetails/GreenTreeDetail.vue
// module id = 1573
// module chunks = 18